import React from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Modal, Typography, CircularProgress } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "250px",
  background: "white",
  borderRadius: "15px",
  boxShadow: 24,
  p: 4,
  outline: "none",
};

function UploadModal({ open, handleClose }) {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <Box sx={{ position: "relative", display: "inline-flex" }}>
            <CircularProgress size={64} thickness={3} sx={{ color: "#166B8E" }} />
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CloudUploadIcon sx={{ fontSize: "30px", color: "#166B8E" }} />
            </Box>
          </Box>
          <Typography sx={{ fontSize: "16px", fontWeight: "600", color: "#166B8E" }}>
            Uploading Image...
          </Typography>
          <Typography sx={{ fontSize: "12px", color: "#64748b" }}>
            Please wait
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}

export default UploadModal;
